<template>
  <div>
    <!--权限编辑弹框-->
    <el-button type="primary" size="mini" @click="add_auth_data"> 新增</el-button>
    <br>
    <el-table size="mini" :header-cell-style="{ background: '#eee', 'color': '#000', border: 0, fontWeight: 400 }" stripe border
      :data="authlist" style="width: 100%;font-weight: 400" height="800px" show-overflow-tooltip="true">
      <el-table-column type="index" label="序号">
      </el-table-column>
      <el-table-column prop="name" label="权限名称">
      </el-table-column>
      <el-table-column prop="url" label="url">
      </el-table-column>
      <el-table-column label="控制按钮">
        <template slot-scope="scope">
          {{ scope.row.checkList.join(' ') }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <div style="display: flex;justify-content: space-around">
            <div class="btn-txt" @click="edit_auth_data(scope.row)">编辑</div>
            <el-popconfirm title="删除后无法恢复？" @confirm="del_auth_data(scope.row)">
              <div class="btn-error" slot="reference">删除</div>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--权限-->
    <el-dialog  width="38%" :close-on-click-modal="false" :close-on-press-escape="false" top="40px" append-to-body destroy-on-close
       @close="handleClose" :visible.sync="auth_add_status" v-if="auth_add_status">
      <el-form size="mini" v-if="auth_add_status" :model="auth_form" label-width="120px">
        <el-form-item required label="权限名称">
          <el-input v-model="auth_form.name"></el-input>
        </el-form-item>
        <el-form-item required label="权限URL">
          <el-input v-model="auth_form.url"></el-input>
        </el-form-item>
        <el-form-item required label="控制按钮显示">
          <el-checkbox-group v-model="auth_form.checkList">
            <el-checkbox v-for="(item, index) in checkList" :label="item" :key="index"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div style="text-align: center; padding: 20px">
        <el-button type="primary" @click="onSubmit" size="mini">保 存</el-button>
        <el-button @click="closeauth" size="mini">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import u from "../../../assets/js/util.js";
export default {
  name: "auth_edit",
  props: ["moduleid"],
  data() {
    return {
      auth_add_status: false,
      checkList: ["新增", "导出", "归档", "作废", "编辑"],
      authlist: [],
      auth_form: {
        checkList: [],
        url: "",
        name: "",
        moduleid: ""
      },
    }
  },
  async mounted() {
    this.auth_form.moduleid = this.moduleid
    this.authlist = await u.post("admin", "auth/query", { moduleid: this.moduleid })
  },
  methods: {
    handleClose() {
      // Object.assign(this.$data, this.$options.data())
    },
    closeauth() {
      this.auth_form.checkList = []
      this.auth_form.url = ""
      this.auth_form.name = ""
      this.auth_form._id = ""
      this.auth_add_status = false
    },
    async onSubmit() {
      var form = this.auth_form
      if (!form.name) {
        u.error("名称不能空")
        return
      }
      if (!form.url) {
        u.error("路径不能空")
        return
      }
      if (!form.moduleid) {
        u.error("请选择所属菜单")
        return
      }
      var res = await u.post("admin", "auth", form)
      if (res !== false) {
        this.closeauth()
        this.authlist = await u.post("admin", "auth/query", { moduleid: form.moduleid })
      }
    },
    add_auth_data() {
      this.auth_add_status = true
    },
    async edit_auth_data(e) {
      this.auth_form = JSON.parse(JSON.stringify(e))
      this.auth_add_status = true
    },
    async del_auth_data(e) {
      var res = await u.post("admin", "auth/del", { _id: e._id })
      if (res !== false) {
        this.authlist = await u.post("admin", "auth/query", { moduleid: this.auth_form.moduleid })
      }
    },
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/page/module/admin/auth_edit.vue